// extracted by mini-css-extract-plugin
export default {"modal":"summary_modal-module___modal___c16fb999"};